import React, { PureComponent } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from 'reactstrap'

class EnterTVName extends PureComponent {
    
    constructor(props) {
        super(props);
    
        this.state = {
            tvName: '',
            confirmText: 'Create',
            cancelText: 'Cancel',
            cancelColor: 'secondary'
          };
        this.onQueryInput = this.onQueryInput.bind(this);
        this.onClickCreate = this.onClickCreate.bind(this);
    }

  componentDidUpdate() {
    this.setState({tvName: this.props.inputValue})
  }

  onQueryInput(e) {
    this.setState({ tvName: e.target.value }, () => {this.props.onChange(this.state.tvName)} );
  }

  onClickCreate() {
    this.props.onCreateTV()
    this.setState({ tvName: ""})
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.props.close}>Enter TV Name</ModalHeader>
        <ModalBody>
        <Input
            type='text'
            name='tvName'
            id='tv-name-input'
            placeholder='TV Name'
            value={this.state.tvName}
            onChange={this.onQueryInput}

        />
        </ModalBody>
        <ModalFooter>
          <Button
            color={this.state.cancelColor}
            onClick={this.props.onClose}
            disabled={this.props.buttonsDisabled}
          >
            {this.state.cancelText}
          </Button>
          <Button
            color="primary"
            onClick={this.onClickCreate}
            disabled={this.props.buttonsDisabled}
          >
            {this.state.confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}
export default EnterTVName;


// WEBPACK FOOTER //
// ./src/views/Components/Modals/EnterTVName.js